import { RequestService } from "../../services/RequestService";
import { GET_SUBJECT_ID_BY_SUBJECT_KEY } from '../constants'

export const getSubjectIdBySubjectKeyRequest = async subjectKey => {
  const response = await RequestService.get(GET_SUBJECT_ID_BY_SUBJECT_KEY + subjectKey)
  return response && response.data && response.data.subjectId
};
